import React, { Fragment, useEffect, useState, useCallback } from "react"
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import _ from "lodash"
import { Check } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { ClientCustomizations, ClientSetup, ClientTemplates } from "."
import { Menubar } from "lib/components"
import { Forms } from "lib/components/forms"


const trxHistoryCols = [
  { label: "Trx Date", prop: "TransactionDate", width: "col-span-2", format: "date" },
  { label: "Amount", prop: "Amount", width: "col-span-1" },
  { label: "BIN", prop: "BIN", width: "col-span-1" },
  { label: "Last Four", prop: "LastFour", width: "col-span-1" },
  { label: "Customer Name", prop: "ConsumerName", width: "col-span-2" },
  { label: "Merch Ref", prop: "MerchantReference", width: "col-span-3" },
  { label: "Type", prop: "ActionType", width: "col-span-1" },
  { label: "Trx Id", prop: "ExternalTransactionId", width: "col-span-2" },
  { label: "AuthCode", prop: "AuthorizationCode", width: "col-span-1" }
]

export default function Client(){

  const navigate = useNavigate()
  const { cid } = useParams()
  const [ searchParams, setSearchParams ] = useSearchParams()

  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { data:_Client } = queryTools.resource.parseQueryForApi("client.findById", { _id: cid })
  const saveMethod = queryTools.resource.save(["client.all"])

  const clientmenu = [
    { 
      refstr: "options", 
      label: "Choose An Option",
      submenus: [
        { type: "option", refstr: "setup", label: "Client Setup", selectFn: ()=>navigate(`/client/${_Client._id}?action=setup`) },
        // { type: "divider"},
        { type: "option", refstr: "templates", label: "Manage Templates", selectFn: ()=>navigate(`/client/${_Client._id}?action=templates`) },
        // { type: "divider"},
        { type: "option", refstr: "customizations", label: "Custom Template Elements", selectFn: ()=>navigate(`/client/${_Client._id}?action=customizations`) },
      ]
    }
  ]


  if( !_Client ) return <></>
  return(
    <div className="w-full h-full border border-solid border-slate-700 p-[2px]">
      <div className="w-full h-8 pl-6 pr-3 flex justify-between items-center bg-slate-700">
        <div className="w-3/12 flex items-center text-white text-sm uppercase">Edit Client: { _Client?.name }</div>
        <Menubar 
          className="w-9/12 flex justify-end items-center text-sm" 
          menus={clientmenu} 
        />
      </div>
      
      <div className="w-full flex flex-col px-4 py-2">

        { searchParams.get("action") === "setup" && (
          <ClientSetup />
        )}

        { searchParams.get("action") === "templates" && (
          <ClientTemplates />
        )}

        { searchParams.get("action") === "customizations" && (
          <ClientCustomizations />
        )}

      </div>
    </div>
  )
}